<router-outlet></router-outlet>
<div kendoDialogContainer></div>
<app-toaster></app-toaster>
